import { Accordion } from 'radix-ui';
import type { Accordion as AccordionNS } from 'radix-ui';
import { forwardRef } from 'react';

import { AccordionHeader, AccordionTrigger, ArrowDown } from './styles';

export type IBaseAccordionProps =
  | AccordionNS.AccordionMultipleProps
  | AccordionNS.AccordionSingleProps;

export const BaseAccordion = forwardRef<HTMLDivElement, IBaseAccordionProps>(
  // eslint-disable-next-line no-restricted-syntax
  function BaseAccordion({ ...props }, ref): JSX.Element {
    return <Accordion.Root ref={ref} {...props} />;
  }
);

export interface IBaseAccordionItemProps
  extends AccordionNS.AccordionItemProps {}

export const BaseAccordionItem = forwardRef<
  HTMLDivElement,
  IBaseAccordionItemProps
  // eslint-disable-next-line no-restricted-syntax
>(function BaseAccordionItem({ ...props }, ref) {
  return <Accordion.Item {...props} ref={ref} />;
});

export interface IBaseAccordionTriggerProps
  extends AccordionNS.AccordionTriggerProps {
  noArrow?: boolean;
}

export const BaseAccordionTrigger = forwardRef<
  HTMLButtonElement,
  IBaseAccordionTriggerProps
  // eslint-disable-next-line no-restricted-syntax
>(function BaseAccordionTrigger({ children, noArrow = false, ...props }, ref) {
  return (
    <AccordionHeader className="AccordionHeader">
      <AccordionTrigger {...props} ref={ref}>
        {children}
        {!noArrow && <ArrowDown aria-hidden />}
      </AccordionTrigger>
    </AccordionHeader>
  );
});

export interface IBaseAccordionContentProps
  extends AccordionNS.AccordionContentProps {}

export const BaseAccordionContent = forwardRef<
  HTMLDivElement,
  IBaseAccordionContentProps
  // eslint-disable-next-line no-restricted-syntax
>(function BaseAccordionContent({ ...props }, ref) {
  return <Accordion.Content {...props} ref={ref} />;
});
